import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {SearchBreedersAction, userDetailAction} from '../action';

function* execute({payload: {searchText}}: SearchBreedersAction): SagaIterator {
    const response = yield* call(Api.searchBreeders, {text: searchText});

    if (response.isSuccess) {
        yield* put(userDetailAction.setBreeders(response.data));
    } else {
        yield putAll(showBeError(response, t('userDetail')('breedersOptionsLoading')));
    }
}

export function* searchBreedersSaga(): SagaIterator {
    yield takeLatestF('userDetail/SEARCH_BREEDERS', execute);
}
